module.exports = {
  "dof-popup": {
    "position": "fixed",
    "overflow": "hidden",
    "zIndex": 1000
  },
  "title": {
    "paddingTop": "30",
    "paddingRight": "30",
    "paddingBottom": "30",
    "paddingLeft": "30",
    "textAlign": "center",
    "fontSize": "28",
    "color": "#8E969B",
    "lineHeight": "48",
    "backgroundColor": "#ffffff"
  },
  "midea-actionsheet-content": {
    "flexDirection": "column",
    "flex": 1
  },
  "midea-actionsheet-list-first": {
    "borderTopWidth": "0",
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "#f5f5f5"
  },
  "midea-actionsheet-list": {
    "borderTopWidth": "2",
    "borderTopColor": "#f9f9f9",
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "#f5f5f5"
  },
  "midea-actionsheet-textWrapper": {
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "midea-actionsheet-text": {
    "fontFamily": "PingFangSC-Regular",
    "textAlign": "center",
    "fontSize": "32",
    "lineHeight": "96"
  },
  "midea-actionsheet-bottom": {
    "flexDirection": "row",
    "marginTop": "16",
    "justifyContent": "space-between"
  },
  "midea-actionsheet-btn": {
    "fontSize": "32",
    "color": "#232323",
    "backgroundColor": "#ffffff",
    "lineHeight": "92",
    "textAlign": "center",
    "flex": 1
  },
  "leftBtn": {
    "color": "#616C73"
  },
  "top": {
    "left": 0,
    "right": 0
  },
  "bottom": {
    "left": 0,
    "right": 0
  },
  "left": {
    "bottom": 0,
    "top": 0
  },
  "right": {
    "bottom": 0,
    "top": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-3594f586!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-actionsheet/index.vue
// module id = 462
// module chunks = 0 1